module.exports = __webpack_public_path__ + "static/media/charge_content.b6a3f23f.png";